export const categoryJson = [
  {
    value: 1,
    label: '少儿英语'
  },
  {
    value: 2,
    label: 'K12'
  },
  {
    value: 3,
    label: '出国语培'
  },
  {
    value: 4,
    label: 'STEM'
  },
  {
    value: 5,
    label: '职业培训'
  },
  {
    value: 6,
    label: '四六级与考研'
  },
  {
    value: 7,
    label: '公立学校'
  },
  {
    value: 8,
    label: '公益组织'
  },
  {
    value: 9,
    label: '对外汉语'
  },
  {
    value: 10,
    label: '国际学校'
  },
  {
    value: 11,
    label: '成人英语'
  },
  {
    value: 12,
    label: '小语种'
  },
  {
    value: 13,
    label: '其他'
  }
]
